import * as types from '@/redux/actionTypes';
import mokaRequest from '@/tools/mokaRequest';
import { getI18n } from '@/utils/i18n';

const i18n = getI18n();

function updateJobList(jobs) {
  return {
    type: types.UPDATE_JOB_LIST,
    payload: { jobs },
  };
}

function updateJob(job) {
  return {
    type: types.UPDATE_JOB,
    payload: { job },
  };
}

function loadingIndicator(type, loading = true) {
  return {
    type: type,
    payload: loading,
  };
}

export function fetchJob(orgId, jobId, contractId) {
  return (dispatch) => {
    dispatch(loadingIndicator(types.LOAD_JOB));

    mokaRequest('/api/outer/ats-jc/headhunter/job', {
      query: { orgId, jobId, contractId },
      actionName: i18n.t`获取职位信息`,
      interceptOnError: true,
    })
      .get()
      .then((job) => {
        dispatch(updateJob({ ...job, contractId }));
        dispatch(loadingIndicator(types.LOAD_JOB, false));
      })
      .catch(() => {
        dispatch(loadingIndicator(types.LOAD_JOB, false));
      });
  };
}

// 获取开放给猎头的职位列表，主要用于职位列表的展示和职位筛选的选项
export function fetchJobList(orgId, callback) {
  return (dispatch) => {
    dispatch(loadingIndicator(types.LOAD_JOB_LIST));

    mokaRequest('/api/outer/ats-jc/headhunter/job-list', {
      query: { orgId },
      actionName: i18n.t`获取职位列表`,
      interceptOnError: true,
    })
      .get()
      .then((jobs) => {
        dispatch(updateJobList(jobs));
        dispatch(loadingIndicator(types.LOAD_JOB_LIST, false));
        callback?.(jobs);
      })
      .catch(() => {
        dispatch(loadingIndicator(types.LOAD_JOB_LIST, false));
      });
  };
}

// 获取现在开放给猎头的 和曾经开放给猎头且猎头推荐了候选人的职位
// 主要用于1.推荐的候选人列表中作职位筛选的选项 2.沟通职位负责人和协助人
export function fetchRelatedJobs(orgId) {
  return (dispatch) => {
    mokaRequest('/api/outer/ats-jc/headhunter/job/related', {
      query: { orgId },
      actionName: i18n.t`获取职位列表`,
      interceptOnError: true,
    })
      .get()
      .then((jobs) => {
        dispatch({
          type: types.UPDATE_RELATED_JOBS,
          payload: { jobs },
        });
      });
  };
}

export function addJobFollowed({ jobId, orgId, contractId, callback }) {
  return (dispatch) => {
    mokaRequest('/api/outer/ats-jc/headhunter/job/follow', {
      actionName: i18n.t`更新关注`,
      interceptOnSuccess: true,
      interceptOnError: true,
    })
      .post({ jobId, orgId, contractId })
      .then((jobs) => {
        dispatch(updateJobList(jobs));
        callback?.(jobs);
      });
  };
}

export function removeJobFollowed({ jobId, orgId, contractId, callback }) {
  return (dispatch) => {
    mokaRequest('/api/outer/ats-jc/headhunter/job/follow', {
      actionName: i18n.t`更新关注`,
      interceptOnSuccess: true,
      interceptOnError: true,
    })
      .del({ jobId, orgId, contractId })
      .then((jobs) => {
        dispatch(updateJobList(jobs));
        callback?.(jobs);
      });
  };
}
